import axios from 'axios';

export default {
    list() {
        return axios.get(window.applicationSettings.apiEndpoint + '/risk/sector/list')
            .then(response => response.data)
            .catch(error => Promise.reject(error.response));
    },
    fetch(sectorId) {
        return axios.get(window.applicationSettings.apiEndpoint + '/risk/sector/fetch/' + sectorId)
            .then(response => response.data)
            .catch(error => error.response);
    },
    create(payload) {
        var formData = new FormData();
        formData.append('data', JSON.stringify(payload));
        return axios.post(window.applicationSettings.apiEndpoint + '/risk/sector/create', formData)
            .then(response => response.data)
            .catch(error => error.response);
    },
    update(sectorId, payload) {
        var formData = new FormData();
        formData.append('data', JSON.stringify(payload));
        return axios.post(window.applicationSettings.apiEndpoint + '/risk/sector/update/' + sectorId, formData)
            .then(response => response.data)
            .catch(error => Promise.reject(error.response));
    },
    delete(sectorId) {
        return axios.delete(window.applicationSettings.apiEndpoint + '/risk/sector/delete/' + sectorId)
            .then(response => response.data)
            .catch(error => Promise.reject(error.response));
    }
}